import React, { useEffect, useRef, useState } from "react";
import { FC } from "react";
import { useStage } from "../queries/stage-queries";
import './lvl-up.css'
import { Navbar, Container } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

export const LevelUp: FC = () => {

    const { currentStage } = useStage()
    const nav = useNavigate()
    const videoRef = useRef<HTMLVideoElement>(null);
    const [donePlay, setDonePlay] = useState(false)
    sessionStorage.removeItem('lvl-up')

    useEffect(() => {
        if (videoRef.current)
            videoRef.current.onended = () => setDonePlay(true)
    }, [videoRef.current])

    const onClick = () => {
        if (donePlay) {
            nav('/')
        }
    }

    return (
        <div>
            <Navbar sticky="top" key={'nav-bar'} expand={false} className="bg-body-secondary">
                <Container fluid>
                    <h2 className="mb-0">LEVEL UP!</h2>
                </Container>
            </Navbar>
            <div style={{ height: '90vh' }} className="d-flex justify-content-center align-items-center">
                <video ref={videoRef} width="100%" height="100%" onClick={onClick} style={{ objectFit: 'cover' }} autoPlay>
                    <source src={`/mov/${currentStage?.label}.mp4`} type="video/mp4" />
                </video>
            </div>
        </div>
    )
}